import { useState } from 'react';
import { Box, Typography, Menu, MenuItem, IconButton, Divider } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import logo from '../assets/logo.jpeg';

const mockSystems = [
  { id: 1, name: 'Joint Operations Network',      cage_code: '1ABC2' },
  { id: 2, name: 'Command & Control System',       cage_code: '3DEF4' },
  { id: 3, name: 'Logistics Management Platform',  cage_code: '5GHI6' },
];

const pageTitles = {
  dashboard: null,  // Dashboard has its own centered ASPYN branding, no page title
  assets:     'Assets',
  vulns:      'Vulnerabilities',
  stig:       'STIG Compliance',
  alerts:     'Alerts',
  c2c:        'Comply to Connect',
  ato:        'ATO / RMF',
  export:     'ATO Export',
  dmz:        'Topology',
  arch:       'Architecture',
  ai:         'AI Assistant',
};

export default function Layout({ children, system, onSystemChange, activePage, onNavigateDashboard, onNavigate }) {
  const [systemAnchor, setSystemAnchor] = useState(null);
  const [accountAnchor, setAccountAnchor] = useState(null);
  const pageTitle = pageTitles[activePage];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#0a0e1a' }}>

      {/* Persistent Header */}
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '10px 24px',
        backgroundColor: '#0d1117',
        borderBottom: '1px solid #1e3a5f',
        position: 'sticky',
        top: 0,
        zIndex: 200,
      }}>

        {/* Left — system selector + ATO status */}
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-start', gap: 1.5 }}>
          <Box
            onClick={(e) => setSystemAnchor(e.currentTarget)}
            sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer', backgroundColor: '#111827', border: '1px solid #1e3a5f', borderRadius: 2, padding: '6px 14px', '&:hover': { border: '1px solid #00bcd4' } }}
          >
            <Box>
              <Typography variant="caption" sx={{ color: '#7a8fa6', display: 'block', lineHeight: 1 }}>CAGE: {system?.cage_code}</Typography>
              <Typography variant="body2" sx={{ color: '#ffffff', fontWeight: 600 }}>{system?.name}</Typography>
            </Box>
            <KeyboardArrowDownIcon sx={{ color: '#7a8fa6', fontSize: 18 }} />
          </Box>

          {/* ATO Status */}
          <Box onClick={() => onNavigate?.('ato')} sx={{ backgroundColor: '#111827', border: '1px solid #1e3a5f', borderRadius: 2, padding: '6px 14px', cursor: 'pointer', '&:hover': { border: '1px solid #00bcd4' } }}>
            <Typography sx={{ color: '#7a8fa6', display: 'block', lineHeight: 1, fontSize: 9, letterSpacing: 0.5 }}>ATO STATUS</Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
              <Box sx={{ width: 7, height: 7, borderRadius: '50%', backgroundColor: '#4caf50' }} />
              <Typography sx={{ color: '#4caf50', fontWeight: 700, fontSize: 16 }}>ACTIVE</Typography>
              <Typography variant="caption" sx={{ color: '#4a5a70', fontSize: 10 }}>· exp 2026-09-30</Typography>
            </Box>
          </Box>
          <Menu anchorEl={systemAnchor} open={Boolean(systemAnchor)} onClose={() => setSystemAnchor(null)}
            PaperProps={{ sx: { backgroundColor: '#111827', border: '1px solid #1e3a5f', color: '#ffffff', minWidth: 240 } }}>
            <MenuItem disabled sx={{ color: '#7a8fa6', fontSize: 11 }}>SWITCH SYSTEM</MenuItem>
            <Divider sx={{ borderColor: '#1e3a5f' }} />
            {mockSystems.map((s) => (
              <MenuItem key={s.id} onClick={() => { setSystemAnchor(null); onSystemChange(); }}
                sx={{ '&:hover': { backgroundColor: '#0d2137' }, backgroundColor: system?.id === s.id ? '#0d2137' : 'transparent' }}>
                <Box>
                  <Typography variant="body2" sx={{ color: '#ffffff', fontWeight: 600 }}>{s.name}</Typography>
                  <Typography variant="caption" sx={{ color: '#7a8fa6' }}>CAGE: {s.cage_code}</Typography>
                </Box>
              </MenuItem>
            ))}
          </Menu>
        </Box>

        {/* Center — ASPYN branding or page title */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center' }}>
          <img src={logo} alt="ASPYN" onClick={onNavigateDashboard} style={{ width: 28, height: 28, borderRadius: '50%', cursor: 'pointer' }} />
          <Typography variant="h6" onClick={onNavigateDashboard} sx={{ color: '#ffffff', fontWeight: 700, letterSpacing: 2, cursor: 'pointer', '&:hover': { color: '#00bcd4' } }}>ASPYN</Typography>
          {pageTitle && (
            <>
              <Typography variant="body2" sx={{ color: '#1e3a5f', mx: 1 }}>|</Typography>
              <Typography variant="h6" sx={{ color: '#00bcd4', fontWeight: 700 }}>{pageTitle}</Typography>
            </>
          )}
        </Box>

        {/* Right — account icon */}
        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton onClick={(e) => setAccountAnchor(e.currentTarget)} sx={{ color: '#7a8fa6', '&:hover': { color: '#00bcd4' } }}>
            <AccountCircleIcon sx={{ fontSize: 30 }} />
          </IconButton>
          <Menu anchorEl={accountAnchor} open={Boolean(accountAnchor)} onClose={() => setAccountAnchor(null)}
            PaperProps={{ sx: { backgroundColor: '#111827', border: '1px solid #1e3a5f', color: '#ffffff' } }}>
            <MenuItem disabled sx={{ color: '#7a8fa6', fontSize: 12 }}>Signed in as jay</MenuItem>
            <Divider sx={{ borderColor: '#1e3a5f' }} />
            <MenuItem sx={{ '&:hover': { backgroundColor: '#0d2137' } }}>Account Settings</MenuItem>
            <MenuItem sx={{ color: '#f44336', '&:hover': { backgroundColor: '#0d2137' } }}>Sign Out</MenuItem>
          </Menu>
        </Box>

      </Box>

      {/* Page Content */}
      <Box sx={{ flex: 1 }}>
        {children}
      </Box>

    </Box>
  );
}
